<template>
	<div class="pat2">
		<div class="main">
			<div class="left">
				<b>About us</b>
				<h1>项目介绍</h1>
				<div class="intr">
					<span>“</span>
					<!-- <div v-html="projectData.projectIntroduction"> </div> -->
					<div>
						<p style="font-weight: bold;">
							中共中央、国务院2016年颁发的《“健康中国2030”规划纲要》提出了“共建共享、全民健康”健康中国建设的战略主题，落实预防为主，推行健康生活方式，减少疾病发生，强化早诊断、早治疗、早康复。国务院正式发布健康中国行动计划，为这一转变描绘了清晰的路线图，其中第一个专项行动就是“健康知识普及行动”。
						</p>
						<p style="font-weight: bold;">
							要实现这一目标，最主要的方式就是开展健康科普，让老百姓愿意看、看得懂、记得住、用得上。针对我国肿瘤诊疗现状和发展趋势，开展新时代健康科普作品征集，汇集卫生健康系统的智慧和力量，集思广益，共同提高，把最优质的健康科普作品奉献给人民群众。
						</p>
					</div>
				</div>
				<el-button @click="aboutAs()">查看更多</el-button>
				<ul class="data">
					<li>
						<b>{{projectData.doctorNum}}</b>
						<i>注册人数</i>
					</li>
					<li>
						<b>{{projectData.documentNum}}</b>
						<i>投稿数量</i>
					</li>
					<li>
						<b>{{projectData.excellentNum}}</b>
						<i>入围作品</i>
					</li>
				</ul>
			</div>

			<el-image :src="projectData.projectImagePath" fit="cover"></el-image>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'pat2',
		props: {
			projectData: Object
		},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		methods: {
			aboutAs() {
				this.$router.push({
					path: '/Intr'
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.pat2 {
		padding: 150px 0;
		background: rgba(247, 248, 250, 1);

		.main {
			width: 1200px;
			margin: auto;
			display: flex;
			flex-direction: row;

			.left {
				flex: 1;

				b {
					color: #28B0A6;
					font-size: 16px;
				}

				h1 {
					font-size: 70px;
					font-weight: 600;
					line-height: 1.5;
				}

				.intr {
					display: flex;
					flex-direction: row;

					span {
						font-size: 50px;
						color: #28B0A6;
						line-height: 1;
						width: 50px;
						display: flex;
						align-items: flex-start;
						justify-content: flex-start;
						text-align: justify;
					}

					>div {
						flex: 1;
						font-size: 14px;
						color: rgba(102, 102, 102, 1);
						line-height: 2;
					}

				}

				.el-button {
					margin-left: 50px;
					background-color: #000;
					color: #fff;
					margin-top: 30px;
				}

				.data {
					margin-top: 50px;
					margin-left: 50px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;

					li {
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: flex-start;

						b {
							font-size: 40px;
							color: #28B0A6;
						}

						i {
							font-style: normal;
							color: rgba(153, 153, 153, 1);
						}
					}
				}
			}

			.el-image {
				width: 440px;
				min-height: 100%;
				margin-left: 120px;
			}
		}
	}
</style>